import React 			from 'react';
import ReactDOM 		from 'react-dom';
import BLComponent		from '../core/_BLComponent.jsx';
import moment			from 'moment';

import InputLabelSet 	from '../common/_InputLabelSet.jsx';
import CustomCheckbox 	from '../common/_CustomCheckbox.jsx';
import CustomRadio 		from '../common/_CustomRadio.jsx';
import blAjax			from '../utils/_ajax.jsx';

import {ClickShowTooltip} 		from '../common/_Utilities.jsx';
import {TermsBase, TermsFormatter} 	from '../terms/_TermsContent.jsx';
import {PrivacyContent} 	from '../terms/_PrivacyContent.jsx';

export default class RegisterMain extends BLComponent 
{
	constructor (props, context) 
	{
		super(props, context);

		this.state = 
			{
				stage: 				0
			,	consent: 			false
			,	emailAddress: 		''
			,	username: 			''
			,	password: 			''
			,	passwordStrength: 	0
			,	dob: 				{month: -1, day: -1, year: -1}
			, 	hasEdited: 			{emailAddress: false, username: false, password: false}
			,	selectedCountry:	blapp.session.codeCountryDetected
			,	selectedState:		-1
			,	typeState:			0			// 0 : No State, 1 : From Select, 2 : Text Input
			,	strTitleState:		"state"
			,	stateManual:		""
			,	errorRegisterMsg:	''

			,	agreeTerms: 		false
			,	agreePrivacy: 		false
			,	agreePrivacyKRM1:	false
			,	agreePrivacyKRM2:	false
			,	agreePrivacyKRO1:	false
			,	agreePrivacyKRO2:	false
			,	returnTo: 			blapp.util.getUrlVar('returnTo') || ''
			,	enableAgreeTerms: 	false
			,	enableAgreePrivacy: false			// No longer used

			,	isDeactivated:		false
			,	isDeleted:			false
			,	marketingNewsletter: false
			,	marketingPersonalAD: false

			, dobHasChanged: false
		}

		this.hasCBDT 			= true;

		this._countries			= null;
		this._countryForState	= null;
		this._states			= null;

		this.funcValidate		= _.debounce( ( chkval ) => this.checkDuplication( chkval ), 500 );

		this._checkUsers		= {};
		this._isProcessing		= false;

		this.preview = blapp.util.getUrlVar('preview') ? true : false;
	}

	componentDidMount() 
	{
		if(blapp.session.isLoggedIn()){
			window.location.href = blapp.url2.getMainPageUrl();
		}
		this.updateStates( this.state.selectedCountry );
	}


	componentDidUpdate() 
	{
		let {emailAddress, username, password} = this.state;
		let hasEdited = this.state.hasEdited;

		if ( !this.state.hasEdited.emailAddress && emailAddress.length ) 
		{
			hasEdited.emailAddress = true;

			this.setState({hasEdited: hasEdited});
		}

		if ( !this.state.hasEdited.username && username.length ) 
		{
			hasEdited.username = true;

			this.setState({hasEdited: hasEdited});
		}
		
		if ( !this.state.hasEdited.password && password.length ) 
		{
			hasEdited.password = true;

			this.setState({hasEdited: hasEdited});
		}

		if ( this.state.stage == 1 ) 
		{
			const _this 					= this;
			const termsContainer 			= this.termsContainer;
			const termsContainerHeight 		= termsContainer.offsetHeight;


			termsContainer.addEventListener('scroll', function(e) {
				if(this.scrollTop + termsContainerHeight >= termsContainer.firstChild.offsetHeight) {
					_this.setState({enableAgreeTerms: true});
				}
			});

			/*
			const privacyContainer 			= this.privacyContainer;
			const privacyContainerHeight 	= privacyContainer.offsetHeight;

			privacyContainer.addEventListener('scroll', function(e) {
				if(this.scrollTop + privacyContainerHeight >= privacyContainer.firstChild.offsetHeight) {
					_this.setState({enableAgreePrivacy: true});
				}
			});
			*/
		}
	}

	render() 
	{
		//return this.renderConsent();
		
		
		if(!blapp.session.isLoggedIn()) {
			if ( this.state.stage == 0 ) 
				return this.renderInitial();
			else
				return this.renderConsent();
		}
		else
			return null;
		
	}

	renderInitial() 
	{
		const	valEmail 		= this.validateInput('emailAddress');
		const valUsername	= this.validateInput('username');
		const valPassword	= this.validateInput('password');
		const valCountry 	= this.validateInput('country');
		const	valState		= this.validateInput('state') || this.state.typeState == 0 || this.state.selectedCountry == 'SE' || this.state.selectedCountry == 'BE';
		const	valDob			= this.state.dobHasChanged && (this.state.dob.month != -1 && this.state.dob.day != -1 && this.state.dob.year != -1) ? this.validateInput('dob') : true;
		const	isAllOK			= this._isEmailValid && this._isUsernameValid && this._isPasswordValid && valCountry && valState && valDob && this.dobNotEmpty();
		const hasEdited 	= this.state.hasEdited;
		const dob 		= this.state.dob;
		return (
			<div className="main l-margin-y--xxl main--m-thin">
				<div className="main__content l-pad-y--null">
					<h1 className="l-margin-bottom--sm text--mxl-title l-block text--center text--bold">Create an account</h1>

					<h2 className="text--title text--bold l-margin-bottom">Account</h2>
					<div className="l-margin-bottom">
						<InputLabelSet classes="l-margin-bottom--sm" data={{label: "Email address", inputValue: this.state.emailAddress, onChangeFunc: this.updateEmailAddress, validation: hasEdited.emailAddress ? (this._isEmailValid ? "ok" : "error") : ""}}/>
						<small className={"text--note l-block" + (valEmail ? " text-color--primaryRed" : "")}>{valEmail ? valEmail : "A confirmation email will be sent to this email address."}</small>
					</div>
					<div className="l-margin-bottom">
						<InputLabelSet classes="l-margin-bottom--sm" data={{label: "Username", inputValue: this.state.username, onChangeFunc: this.updateUsername, validation: hasEdited.username ? (this._isUsernameValid ? "ok" : "error") : "", maxLength: "15"}}/>
						<small className={"text--note l-block" + (valUsername ? " text-color--primaryRed" : "")}>{valUsername ? valUsername : "Only use letters, numbers, periods (.), or underscores (_)."}</small>
					</div>
					<div className="l-margin-bottom--xl">
						<InputLabelSet classes="l-margin-bottom--sm" data={{label: "Password", inputValue: this.state.password, onChangeFunc: this.updatePassword, type: 'password', password: true, validation: hasEdited.password ? (this._isPasswordValid ? "ok" : "error") : "", maxLength: "15" }}/>
						<small className="text--note l-block">{valPassword ? this.renderPasswordStrength() : <span>Your password must be 8-15 characters long without spaces and is case sensitive. Use only letters, numbers, and certain special characters.<i className="l-margin-left--sm fa fa-info-circle text-color--lighterDarkest" data-tooltip-width={200} data-tooltip={`Acceptable special characters: _.-[]/{}()*+?^$|~!@#%&()\`=;’,><:\”`} onClick={(e) => ClickShowTooltip(e)}/></span>}</small>
					</div>

					<h2 className="text--title text--bold l-margin-bottom">Date of birth<i className="fas fa-info-circle text--small l-margin-left--sm" data-tooltip-width={200} data-tooltip={"This information is only used for age verification."} onClick={(e) => ClickShowTooltip(e)}/></h2>
					<div className="l-margin-bottom--xl">
						<div className="l-flex l-center l-margin-bottom--sm">
							<select className={"select l-margin-right" + (!valDob ? ' border-color--primaryRed' : '')} value={this.state.dob.month} onChange={(e) => this.updateDate(e, 'month')}>
								<option value={-1}>MM</option>
								{this.renderMonths()}
							</select>
							<select className={"select l-margin-right" + (!valDob ? ' border-color--primaryRed' : '')} value={this.state.dob.day} onChange={(e) => this.updateDate(e, 'day')}>
								<option value={-1}>DD</option>
								{this.renderDays(dob)}
							</select>
							<select className={"select" + (!valDob ? ' border-color--primaryRed' : '')} value={this.state.dob.year} onChange={(e) => this.updateDate(e, 'year')}>
								<option value={-1}>YYYY</option>
								{this.renderYears()}
							</select>
						</div>
						<small className={"text--small l-block" + (!valDob ? ' text-color--primaryRed' : '')}>{!valDob ? "I am sorry you are not eligible to create an account." : ""}</small>
					</div>

					<h2 className="text--title text--bold l-margin-bottom l-flex l-center">Location<i className="fas fa-info-circle text--small l-margin-left--sm" data-tooltip-width={200} data-tooltip={"We use your location to find local stores and better personalize your shopping experience."} onClick={(e) => ClickShowTooltip(e)}/></h2>
					<div className="l-margin-bottom">
						<select className={"select l-full-width" + (!valCountry ? ' border-color--primaryRed' : '')} value={this.state.selectedCountry} onChange={this.updateCountry}>
							{this.renderCountries()}
						</select>
						{!valCountry && <small className="text--small text-color--primaryRed l-margin-top--sm l-block">We do not currently allow account creation in this country.</small>}
					</div>
					<div className="l-margin-bottom">
						{this.renderStates()}
						{!valState && this.state.typeState != 0 ? <small className="text--small text-color--primaryRed l-margin-top--sm l-block">Please select a {this.state.strTitleState.toLowerCase()}.</small> : null}
					</div>
					<button className="btn btn--cta text--bold l-full-width" disabled={!isAllOK} onClick={isAllOK ? () => this.setState({stage: 1}) : null}>Next</button>
				</div>
			</div>
		);
	}

	renderConsent() 
	{
		let consentAgreed	= false;

		if ( this.state.selectedCountry == "KR" )
			consentAgreed	= this.state.agreeTerms && this.state.agreePrivacyKRM1 && this.state.agreePrivacyKRM2;
		else
			consentAgreed	= this.state.agreeTerms && this.state.agreePrivacy;

		return (
			<div className="main l-margin-y--xxl main--m-thin">
				<div className="main__content l-pad-y--null">
					<h1 className="l-margin-bottom--sm text--mxl-title l-block text--center text--bold">Create an account</h1>
					{this.renderTerms()}
					{this.renderPrivacyPolicy()}
					{this.renderMarketing()}
					{this.state.errorRegisterMsg != '' ? <div className="text-color--primaryRed text--center l-margin-bottom">{this.state.errorRegisterMsg}</div> : null}
					<div className="l-flex l-start l-margin-bottom--xl text--no-break">
						<strong>For this purpose, LEGO BrickLink Inc. and LEGO Systems A/S will share data with their partners. I can withdraw my consent by clicking the unsubscribe button in e-mails received, or as described in the Privacy Policy.​</strong>
					</div>
					<button className="btn btn--cta text--bold l-full-width" disabled={this._isProcessing || !consentAgreed } onClick={consentAgreed ? () => this.createAccount() : null}>Create account</button>
				</div>
			</div>
		);
	}

	renderTerms() 
	{
		const isPreviewTerms = TermsBase().findIndex(item => item.preview == true) != -1;

		const activeTerms = TermsBase().filter(item => item.preview == false).sort((itemA, itemB) => itemA.updated > itemB.updated ? -1 : 1);
		const terms = this.preview && isPreviewTerms ? TermsBase()[TermsBase().findIndex(item => item.preview == true)] : activeTerms[0];

		return (
			<section className="l-margin-bottom">
				<h2 className="text--title text--bold l-margin-bottom">Terms of Service</h2>
				<div ref={termsContainer => this.termsContainer = termsContainer} className="scroll-container scroll-container--tall l-margin-bottom--l base-formating base-formating--advanced l-pad--null">
					<article className="l-margin">
						{terms.content}
					</article>
				</div>

				<div className="l-margin-bottom--xl l-full registration--tos-warning">
					<i className="fas fa-exclamation-triangle registration--warning-sign"></i> You must read the entire Terms of Service to proceed.
				</div>

				<label className="l-flex">
					<div className="js-bottom-center-tooltip" data-tooltip-width={200} data-tooltip={"To activate the checkbox, read and scroll through to the end of the Terms of Service Agreement."} onClick={!this.state.enableAgreeTerms ? (e) => {e.preventDefault(); ClickShowTooltip(e)} : null}> 
						<CustomCheckbox classes="l-margin-right" isDisabled={!this.state.enableAgreeTerms} isChecked={this.state.agreeTerms} isDark onChangeFunc={this.state.enableAgreeTerms ? () => this.setState({agreeTerms: !this.state.agreeTerms}) : () => {return false}}/>
					</div>
					<div className="registration--checkbox-message">
						<div className="js-bottom-center-tooltip" data-tooltip-width={200} data-tooltip={"To activate the checkbox, read and scroll through to the end of the Terms of Service Agreement."} onClick={!this.state.enableAgreeTerms ? (e) => {e.preventDefault(); ClickShowTooltip(e)} : null}> 
						<p className={!this.state.enableAgreeTerms ? ' text-color--lightGrey' : ''}>By clicking this box, I confirm that I have read, understand, and agree to this Terms of Service Agreement.</p>
						</div>
						<p className="registration--print-link">
							<a href={blapp.url2.getGeneralUrl( "/terms_of_service.page" )} target="_blank">Print a copy of the Terms of Service Agreement <i class="far fa-external-link-square-alt"></i></a>
						</p>
					</div>
				</label>
			</section>
		);
	}

	renderPrivacyPolicy() 
	{
		let	consentType = 1;

		switch ( this.state.selectedCountry )
		{
		case "CA":	// Canada
		case "CN":	// China
		case "HK":	// HongKong
		case "SG":	// Singapore
			consentType	= 2;
			break;
		case "KR":	// South Korea
			consentType	= 3;
			break;
		}

		switch ( consentType )
		{
		case 2:		return this.renderPrivacyPolicyConsentType2();
		case 3:		return this.renderPrivacyPolicyConsentType3();
		default:	return this.renderPrivacyPolicyConsentType1();
		}


		/*
		return (
			<section className="l-pad-bottom--xl l-border--bottom l-margin-bottom--xl">
				<h2 className="text--xl-title l-margin-bottom">Privacy Policy</h2>
				<div ref={privacyContainer => this.privacyContainer = privacyContainer} className="scroll-container scroll-container--tall l-margin-bottom">
					<article>
						{this.returnPolicy()}
					</article>
				</div>
				<label className="l-flex">
					<CustomCheckbox classes="l-margin-right" isDisabled={!this.state.enableAgreePrivacy} isChecked={this.state.agreePrivacy} isDark onChangeFunc={this.state.enableAgreePrivacy ? () => this.setState({agreePrivacy: !this.state.agreePrivacy}) : () => {return false}}/>
					<div>
						<p className={"l-margin-bottom" + (!this.state.enableAgreePrivacy ? ' text-color--lightGrey' : '')}>By clicking this box, I confirm that I have read, understand, and agree to this Privacy Policy Agreement.</p>
						<p>To print a copy of the Privacy Policy Agreement please <a href="//www.bricklink.com/help.asp?helpID=47" target="_blank">click here</a>.</p>
					</div>
				</label>
			</section>
		);
		*/
	}

	renderPrivacyPolicyConsentType1()
	{
		return (
			<section className="l-pad-bottom--xl l-border--bottom l-margin-bottom--xl">
				<label className="l-flex">
					<CustomCheckbox classes="l-margin-right" isChecked={this.state.agreePrivacy} isDark onChangeFunc={() => this.setState({agreePrivacy: !this.state.agreePrivacy})}/>
					<div className="registration--checkbox-message">
						<p>By clicking this box, I confirm that I have read and understand the <a href={blapp.url2.getGeneralUrl( "/privacy_policy.page" )} target="_blank">Privacy Policy</a>.</p>
						<p className="registration--print-link">
							<a href={blapp.url2.getGeneralUrl( "/privacy_policy.page" )} target="_blank">Print a copy of the Privacy Policy <i class="far fa-external-link-square-alt"></i></a>
						</p>
					</div>
				</label>
			</section>
		);
	}

	renderPrivacyPolicyConsentType2()
	{
		return (
			<section className="l-pad-bottom--xl l-border--bottom l-margin-bottom--xl">
				<label className="l-flex">
					<CustomCheckbox classes="l-margin-right" isChecked={this.state.agreePrivacy} isDark onChangeFunc={() => this.setState({agreePrivacy: !this.state.agreePrivacy})}/>
					<div className="registration--checkbox-message">
						<p>By clicking this box, I confirm that I have read, understand, and agree to the Privacy Policy and consent to BrickLink Limited collecting, using, disclosing (including overseas transfers) and otherwise processing my personal information (including your sensitive personal information, if any) in accordance with the <a href={blapp.url2.getGeneralUrl( "/privacy_policy.page" )} target="_blank">Privacy Policy</a>.</p>
						<p className="registration--print-link">
							<a href={blapp.url2.getGeneralUrl( "/privacy_policy.page" )} target="_blank">Print a copy of the Privacy Policy <i class="far fa-external-link-square-alt"></i></a>
						</p>
					</div>
				</label>
			</section>
		);
	}

	renderPrivacyPolicyConsentType3()
	{
		const isPreviewPolicy = PrivacyContent().findIndex(item => item.preview == true) != -1;

		const activePolicies = PrivacyContent().filter(item => item.preview == false).sort((itemA, itemB) => itemA.updated > itemB.updated ? -1 : 1);
		const policy = this.preview && isPreviewPolicy ? PrivacyContent()[PrivacyContent().findIndex(item => item.preview == true)] : activePolicies[0];

		return (

			<section className="l-margin-bottom--xl">
				<h2 className="text--xl-title l-margin-bottom">Privacy Policy</h2>
				<div ref={privacyContainer => this.privacyContainer = privacyContainer} className="scroll-container scroll-container--tall l-pad-null l-margin-bottom--xl base-formating base-formating--advanced">
					<article className="l-margin">
						{policy.content}
					</article>
				</div>
				<h2 className="text--title text--bold l-margin-bottom">Mandatory</h2>
				<label className="l-flex l-margin-bottom">
					<CustomCheckbox classes="l-margin-right" isChecked={this.state.agreePrivacyKRM1} isDark onChangeFunc={() => this.setState({agreePrivacyKRM1: !this.state.agreePrivacyKRM1})}/>
					<p>By clicking this box, I confirm that I have read, understand, and agree to the Privacy Policy and consent to BrickLink Limited’s <b>mandatory collection and usage of my personal information</b> in accordance with the <a href={blapp.url2.getGeneralUrl( "/privacy_policy.page" )} target="_blank">Privacy Policy</a>.</p>
				</label>
				<label className="l-flex l-margin-bottom">
					<CustomCheckbox classes="l-margin-right" isChecked={this.state.agreePrivacyKRM2} isDark onChangeFunc={() => this.setState({agreePrivacyKRM2: !this.state.agreePrivacyKRM2})}/>
					<p>By clicking this box, I confirm that I have read, understand, and agree to the Privacy Policy and consent to BrickLink Limited’s <b>mandatory sharing of my personal information with third parties</b> in accordance with the <a href={blapp.url2.getGeneralUrl( "/privacy_policy.page" )} target="_blank">Privacy Policy</a>.</p>
				</label>
				<h2 className="text--title text--bold l-margin-bottom">Optional</h2>
				<label className="l-flex l-margin-bottom">
					<CustomCheckbox classes="l-margin-right" isChecked={this.state.agreePrivacyKRO1} isDark onChangeFunc={() => this.setState({agreePrivacyKRO1: !this.state.agreePrivacyKRO1})}/>
					<p>By clicking this box, I confirm that I have read, understand, and agree to the Privacy Policy and consent to BrickLink Limited’s <b>optional collection and usage of my personal information</b> in accordance with the <a href={blapp.url2.getGeneralUrl( "/privacy_policy.page" )} target="_blank">Privacy Policy</a>.</p>
				</label>
				<label className="l-flex l-margin-bottom">
					<CustomCheckbox classes="l-margin-right" isChecked={this.state.agreePrivacyKRO2} isDark onChangeFunc={() => this.setState({agreePrivacyKRO2: !this.state.agreePrivacyKRO2})} />
					<p>By clicking this box, I confirm that I have read, understand, and agree to the Privacy Policy and consent to BrickLink Limited’s <b>optional sharing of my personal information with third parties</b> in accordance with the <a href={blapp.url2.getGeneralUrl( "/privacy_policy.page" )} target="_blank">Privacy Policy</a>.</p>
				</label>
				<p style={{ marginLeft: "32px" }} >To print a copy of the Privacy Policy, please <a href={blapp.url2.getGeneralUrl( "/privacy_policy.page" )} target="_blank">click here</a>.</p>				
			</section>
		);
	}	

	renderMarketing() 
	{
		return (
			<section className="l-margin-bottom--xl">
				<div className="l-margin-bottom">
					<h2 className="text--title l-margin-bottom text--bold l-block">Subscriptions</h2>
					<p>By email:</p>
				</div>
				<label className="l-flex l-margin-bottom">
					<CustomCheckbox classes="l-margin-right" isChecked={this.state.marketingNewsletter} isDark onChangeFunc={()=> this.setState({marketingNewsletter: !this.state.marketingNewsletter})}/>
					<p>BrickLink Newsletter</p>
				</label>
				<label className="l-flex l-margin-bottom">
					<CustomCheckbox classes="l-margin-right" isChecked={this.state.marketingPersonalAD} isDark onChangeFunc={() => this.setState({marketingPersonalAD: !this.state.marketingPersonalAD})}/>
					<p>BrickLink Marketing News​</p>
				</label>
			</section>
		);
	}

	renderPasswordStrength()
	{
		const passwordStrength 			= this.state.passwordStrength;
		const passwordStrengthVerbs 	= ['Weak', 'Modest', 'Good', 'Strong'];

		return (
			<span>
				Password strength: {passwordStrengthVerbs[passwordStrength]}
				<ul className={"l-margin-left password-strength-notification password-strength-notification--" + passwordStrength}>
					<li className="notification-dot password-strength-notification__item"/>
					<li className="notification-dot password-strength-notification__item"/>
					<li className="notification-dot password-strength-notification__item"/>
					<li className="notification-dot password-strength-notification__item"/>
				</ul>
			</span>
		);
	}

	createAccount() 
	{
		let consentAgreed = false;
		if ( this.state.selectedCountry == "KR" )
			consentAgreed	= this.state.agreeTerms && this.state.agreePrivacyKRM1 && this.state.agreePrivacyKRM2;
		else
			consentAgreed	= this.state.agreeTerms && this.state.agreePrivacy;


		if ( this._isProcessing == false )
		{
			this._isProcessing	= true;

			blAjax.call(
				"/signup.ajax"
			,	{
					strEmailAddr:	this.state.emailAddress
				,	strUsername:	this.state.username
				,	strPassword:	this.state.password
				,	codeCountry:	this.state.selectedCountry
				,	strState:		this.state.typeState == 0 ? "" : ( this.state.typeState == 1 ? this.state.selectedState : this.state.stateManual )
				,	urlReturn:		this.state.returnTo
				,	strPageID:		blapp.util.getPageID()
				,	bMarketingNewsletter: this.state.marketingNewsletter
				,	bMarketingAds:	this.state.marketingPersonalAD
				,	bNewTOSConsent: consentAgreed
				,	strUserBirthDate: `${this.state.dob.year}-${this.state.dob.month}-${this.state.dob.day}`
				,	agreePrivacyKRO2: this.state.agreePrivacyKRO1
				,	agreePrivacyKRO5: this.state.agreePrivacyKRO2
				,	agreePrivacyKRO6: false
				}
			).then(
				( data ) => 
				{
					if ( data.result == "EC_OK" || data.result == "EC_SIGNUP_EMAIL_FAILURE" )
					{
						this.setState( { errorRegisterMsg: '' } );
						if ( data.session != null )
							blapp.session.set( data.session, false );

						window.location.href = this.state.returnTo == '' ? blapp.url2.getMainPageUrl() : this.state.returnTo;
						
						//blapp.refs.get( "header" ).toggleMenu( 'confirm_email' );
					}
					else
					{
						this._isProcessing	= false;
						this.setState( { errorRegisterMsg: this.convertToErrorMsg( data.result ) } );
					}
				}
			).catch(
				( err ) =>
				{
					this._isProcessing	= false;
					this.setState( { errorRegisterMsg: err } );
				}
			);
		}
	}

	validateInput(type) 
	{
		const bannedCountries = ['CU', 'IR', 'SY', 'KP'];
		//const bannedCountries = ['CU', 'IR', 'SY', 'KP', 'UA', 'RU'];

		switch ( type ) 
		{
			case 'emailAddress':
				const emailCheck = this._checkUsers[ this.state.emailAddress ];
				this._isEmailValid	= false;
				
				if ( emailCheck == 'EC_SIGNUP_EMAIL_DEACTIVATED' ) 
					return <span>This account is deactivated.</span>
				else if ( emailCheck == 'EC_SIGNUP_EMAIL_EXISTS' )
					return "This email is already in use.";
				else if ( this.state.emailAddress == "" || !blapp.util.isValidEmailAddr( this.state.emailAddress ) )
					return "";

				this._isEmailValid	= true;
				return "";

			case 'username':
				const usernameCheck = this._checkUsers[ this.state.username ];
				this._isUsernameValid	= false;

				if ( usernameCheck == 'EC_SIGNUP_USERNAME_DEACTIVATED' ) 
					return <span>This account is deactivated.</span>
				else if ( usernameCheck == 'EC_SIGNUP_USERNAME_EXISTED' ) 
					return <span>This username is not available.</span>
				else if ( usernameCheck == 'EC_SIGNUP_USERNAME_EXISTS' )
					return "A user with that name already exists.";
				else if ( usernameCheck == 'EC_SIGNUP_INVALID_USERNAME' )
					return <span>This username is not allowed.</span>
				else if ( this.state.username.length > 15 )
					return "Username is exceeding 15 characters.";
				else if ( this.state.username == "" )
					return "";

				this._isUsernameValid	= true;
				return "";

			case 'password':
				if ( this.state.password != null && this.state.password.length >= 8 && this.state.password.length <= 15 && this.state.password.indexOf( ' ' ) == -1 && this.validatePassword() )
				{
					this._isPasswordValid	= true;
					return true;
				}

				this._isPasswordValid	= false;
				return false;

			case 'country':
				if (bannedCountries.includes(this.state.selectedCountry))
					return false;
				else
					return true;

			case 'dob':
				if(this.state.dobHasChanged && (this.state.dob.month != -1 && this.state.dob.day != -1 && this.state.dob.year != -1)) {
					const enteredDate = moment().year(this.state.dob.year).month(this.state.dob.month-1).date(this.state.dob.day)
					const today = moment();
					const yearsBetween = today.diff(enteredDate, 'years');
					const validAge = 18;

					if(yearsBetween >= validAge) {
						return true;
					}else{
						return false;
					}
				}

			case 'state':
				if ( ( this.state.typeState == 1 && this.state.selectedState != -1 ) 
					|| ( this.state.typeState == 2 && this.state.stateManual.trim() != "" ) )
				{
					return true;
				}

				return false;
		}
	}

	dobNotEmpty()
	{
		return this.state.dob.day != -1 && this.state.dob.month!= -1 && this.state.dob.year != -1;
	}

	renderCountries() 
	{
		if(this._countries != null)
			return this._countries;

		this._countries	= _.map(blapp.country.arrCountry, (c, key) => (<option value={c.codeCountry} key={key}>{c.strCountryName}</option>));

		return this._countries;
	}

	renderStates() 
	{
		if (this.state.typeState == 1) 
		{
			const strTitleState = this.state.strTitleState.toLowerCase();
			return ( 
				<select className={"select l-full-width l-margin-bottom" + ( this.state.selectedCountry != 'SE' && this.state.selectedCountry != 'BE' && this.state.selectedState == -1 ? " border-color--primaryRed" : "")} value={this.state.selectedState} onChange={(e)=>this.setState({selectedState: e.target.value})}>
					<option key={-1} value={-1}>-- Select {strTitleState} -- </option>
					{this._states}
				</select>
			);
		}
		else if(this.state.typeState == 2) 
		{
			return (
				<InputLabelSet classes="l-margin-bottom l-margin-top--sm" data={{id: "logindlg_l_statename", focus: true, label: this.state.strTitleState, inputValue: this.state.stateManual, onChangeFunc: (newval)=>this.setState( {stateManual: newval } ) }}/>
			);
		}

		return null;
	}

	updateCountry = (e) =>
	{
		var	newCountry	= e.target.value;

		if ( newCountry != this.state.selectedCountry )
		{
			this.setState( { selectedCountry: newCountry } );
			this.updateStates( newCountry );
		}
	}

	updateEmailAddress = (newval) =>
	{
		this.setState({emailAddress: newval});

		if ( blapp.util.isValidEmailAddr( newval ) )
			this.funcValidate( newval );
	}

	updateUsername = (newval) => 
	{
		var	newval	= newval.replace( /[^a-zA-Z0-9\._]/g, '' );
		this.setState( {username: newval} );

		this.funcValidate( newval );
	}

	updateLoginname = (newval) => 
	{
		this.setState( {loginname: newval} );
	}

	updatePassword = (newval) =>
	{
		this.setState({password: newval});
		this.updatePasswordStrength(newval);
	}

	updatePasswordStrength( newval ) 
	{
		const 	password = newval;
		let 	strength = 0;

		const digit 		= /\d/g;
		const uppercase = /[A-Z]/g;
		const special 	= /[\!\@\#\$\%\^\&\*\)\(\+\=\.\_\-\;\:\[\]\{\}\?\<\>\,]/g;

		strength = password.match(digit) ? strength + 1 : strength;
		strength = password.match(uppercase) ? strength + 1 : strength;
		strength = password.match(special) ? strength + 1 : strength;

		this.setState({passwordStrength: strength});
	}

	validatePassword()
	{
		const exp 	= /[a-zA-Z0-9\!\@\#\$\%\^\&\*\)\(\+\=\.\_\-\;\:\[\]\{\}\?\<\>\,\/\\\|\~<>'`"]+/g;
		let match = this.state.password.match(exp);
		return match[0] == this.state.password;
	}

	checkDuplication( chkVal )
	{
		if ( this._checkUsers[ chkVal ] != null )
			return;

		blapp.models.fetch(
			"_checkuser"
		,	{ 
				controller: "user.BLCUserBasic"
			,	method: 	"checkKeyAvailable"
			,	params: 	[ chkVal ]
			,	refresh:	true 
			}
		).then(
			( data ) =>
			{
				if ( data != null )
				{
					this._checkUsers[ chkVal ]	= data;
					this.setState( { dummy: this.state.dummy + 1 } );
				}
			}
		).catch(
			( err ) => console.log( err )
		);
	}

	updateStates = ( newCountry ) =>
	{
		var	countryInfo			= blapp.country.get( newCountry );
		var	typeState			= 0;
		var	strTitleState		= "state";
		var	selectedState		= -1;
		var	hasStateGroup		= 0;

		if ( countryInfo != null )
		{
			var addressFormat	= blapp.address.getFormat( countryInfo.idAddressFormat );
			var	statesNew		= _.sortBy( countryInfo.arrStatesNew, [ (s) => { if ( s.hasOwnProperty( "idStateNewParent" ) && s.idStateNewParent > 0 ) return s.idStateNewParent; return 999999; }, "strStateName" ] );
			var statesElem		= [];
			var statesGroup		= [];
			var	prevGroupID		= -1;
			var	curGroup			= null;

			if ( addressFormat != null )
				strTitleState	= addressFormat.strTitleState;

			if ( addressFormat != null && ( addressFormat.typeState == 1 || addressFormat.typeState == 2 ) )
			{
				if ( statesNew.length > 0 )
				{
					for ( var i = 0; i < statesNew.length; ++ i )
					{
						var	curState	= statesNew[ i ];

						if ( curState.hasOwnProperty( "idStateNewParent" ) && curState.idStateNewParent > 0 )
						{
							hasStateGroup	= 1;

							if ( prevGroupID != curState.idStateNewParent )
							{
								prevGroupID	= curState.idStateNewParent;

								if ( curGroup != null )
									statesGroup.push( curGroup );

								curGroup	= blapp.country.getStateNew( prevGroupID );

								if ( curGroup != null )
								{
									curGroup				= _.clone( curGroup );
									curGroup.childs	= [];								
								}
							}
							
							if ( curGroup != null )
								curGroup.childs.push( curState );
						}
						else if ( hasStateGroup == 0 )
						{
							if ( curGroup != null )
								statesGroup.push( curGroup );

							curGroup				= _.clone( curState );
							curGroup.childs	= [];
						}
					}

					if ( curGroup != null )
						statesGroup.push( curGroup );

					statesGroup	= _.sortBy( statesGroup, [ "strStateName" ] );
					statesElem	= _.map( 
										statesGroup
									, 	function ( g )
										{
											if ( g.childs.length == 0 )
												return ( <option key={g.idStateNew} value={g.strStateName}>{g.strStateName}</option> );
											return (
												<optgroup key={g.idStateNew} label={g.strStateName}>
												{ _.map( g.childs, ( gc ) => <option key={gc.idStateNew} value={gc.strStateName}>{gc.strStateName}</option> ) }
												</optgroup>
											);
										}
									);

					typeState		= 1;
				}
				else
				{
					typeState		= 2;

				}
			}
			else
			{
				typeState	= 0;
			}
		}
		else
		{
			typeState	= 0;
		}
	
		this._states	= statesElem;

		if ( newCountry == blapp.session.codeCountryDetected && blapp.session.idStateDetected > 0 )
		{
			var	stateLegacy	= blapp.country.getStateLegacy( blapp.session.idStateDetected );
			if ( stateLegacy != null )
				selectedState	= stateLegacy.strStateName;
		}

		this.setState( { typeState: typeState, strTitleState: strTitleState, selectedState: selectedState } );
	}

	updateDate(e, type) 
	{
		let newDob = this.state.dob;
		newDob[type] = e.target.value;
		const {month, year, day} = newDob;
		if (parseInt(month) > 0) {
			const maxDay = this.calcMaxDayofMonth( parseInt(year), parseInt(month) );
		
			if ( (parseInt(day) > 0) && (maxDay < parseInt(day)) )
			{
				newDob["day"] = -1;
			}
		}
		this.setState({dob: newDob, dobHasChanged: true});
	}

	renderMonths() 
	{
		let months = [];

		for(let i = 1; i <= 12; i++) {
			months.push(<option key={i} value={i}>{i}</option>);
		}

		return months;
	}

	renderDays(dob) 
	{
		let days = [];
		let maxDay = 31;

		if (typeof dob != "undefined") {
			const {month, year} = dob;
			if ( parseInt(month) > 0) {
				maxDay = this.calcMaxDayofMonth(parseInt(year), parseInt(month));
			}
		}

		for(let i = 1; i <= maxDay; i++) {
			days.push(<option key={i} value={i}>{i}</option>);
		}

		return days;
	}

	renderYears() 
	{
		let years = [];
		const thisYear = new Date().getFullYear();

		for(let i = thisYear; i >= thisYear - 100; i--) {
			years.push(<option key={i} value={i}>{i}</option>);
		}

		return years;
	}

	returnTerms() 
	{
		return (
			<div className="base-formating">
				Soon
			</div>
		);
	}

	/*
	returnPolicy() 
	{
		return (
			<div className="base-formating">
				<p>
					BrickLink respects the privacy of our members.  BrickLink does not send you unsolicited e-mail or sell your e-mail address to 3rd parties and will never give out your address, e-mail address, and/or phone number to anyone except to those registered BrickLink members with whom you do business.  Your personal information including any or all of your data can be however provided to verified law enforcement who are investigating an illegal activity or a crime.
				</p>

				<p>
					BrickLink stores cookies on your computer which contain your login info as well as counters and identifiers to deliver content specific to you.  Users who do not allow cookies will not be able to login to the site and therefore will not have access to any area that a registered member or registered seller has access to.
				</p>

				<p>
					<h2>Name, Address and E-Mail Address:</h2>
				</p>

				<div className="l-margin-left">
					<p>
						Your name, address, e-mail address, and phone number (if provided) is e-mailed to both the buyer and seller when an order is submitted.  After the order is submitted, both the buyer and seller may view each other's name, address and e-mail address by going into <a target="_blank" href="orderPlaced.asp">Orders Placed</a> or <a target="_blank" href="orderReceived.asp">Orders Received</a>.  Our system checks if you have done business with a member before revealing you their address.  The address and e-mail address is viewable online by the buyer and seller until the order is purged from the system (180 days from the order date)
					</p>
					<p>
						Posting other member's address, e-mail address or phone number in the <a target="_blank" href="/messageList.asp">Discussion Forum</a> is prohibited and results in the post being Cancelled by a Discussion Forum Moderator when spotted.
					</p>
					<p>
						Feedback you received from your buyer or seller containing your personally identifying information such as your name or e-mail address is a valid reason for removal of the feedback on the <a target="_blank" href="/feedbackDel.asp">Feedback Removal Request</a> page.
					</p>
					<p>
						If another member has posted your personally identifying information such as your address or e-mail address on their <a target="_blank" href="/help.asp?helpID=66">Splash Page</a> or <a target="_blank" href="/help.asp?helpID=158">About Me Page</a>, you can report that member on the <a target="_blank" href="/problemMember.asp">Problem with Member</a> page.
					</p>
				</div>

				<p>
					<h2>IP Address and Last Login Date:</h2>
				</p>

				<div className="l-margin-left">
					<p>
						BrickLink keeps track of your IP address which is recorded upon each login.  The buyer's IP address is provided to the seller on the Order Notification E-Mail that is sent to the buyer and the seller at the time an order is placed to help the seller determine if a buyer has 2 or more profiles on the system.  Buyer and seller can view each other's last login date and time on the <a target="_blank" href="orderPlaced.asp">Orders Placed</a> or <a target="_blank" href="orderReceived.asp">Orders Received</a> page to help determine if there is a problem in communication.
					</p>
				</div>

				<p>
					<h2>E-Mail Opt-In / Opt-Out:</h2>
				</p>

				<div className="l-margin-left">
					<p>
						Members must opt-in or perform certain activity to receive e-mails from BrickLink which varies depending on what activity was performed.  For more information, see <a target="_blank" href="/help.asp?helpID=972">List of BrickLink E-Mails</a> which includes a short explanation of each e-mail and when and to whom it is sent.
					</p>
					<p>
						Members can opt-out of receiving all e-mails from BrickLink on the <a target="_blank" href="/unregister.asp">Unregister from BrickLink</a> page.
					</p>
				</div>

				<p>
					<h2><em>Contact Form:</em></h2>
				</p>

				<div className="l-margin-left">
					<p>
						If you have selected to allow contact upon registration, any registered BrickLink member can contact you using our <a target="_blank" href="/help.asp?helpID=69">Contact Form</a> where your e-mail address is not revealed to the sender.  Be advised that you can receive unsolicited e-mail from other members sent via our e-mail server if you choose this option.  You have an option to turn off this feature if you do not want to be contacted by visiting <a target="_blank" href="/pref_contact.asp">My Contact Settings</a>.
					</p>
					<p>
						Sellers can be contacted regardless of preference through a contact link in the seller's store only.  A member can be contacted regardless of preference by their trading partner regarding an order that has not yet been purged from the system (180 days from the order date)
					</p>
				</div>

				<p>
					<h2><em>Coupon Notification:</em></h2>
				</p>

				<div className="l-margin-left">
					<p>
						If you have selected to be notified by e-mail when a seller issues you a coupon, you may receive unsolicited coupons from BrickLink sellers.  You have an option to turn off this notification by visiting <a target="_blank" href="/pref_contact.asp">My Contact Settings</a>.
					</p>
				</div>

				<p>
					<h2><em>Store Mailing List:</em></h2>
				</p>

				<div className="l-margin-left">
					<p>
						Members can opt-in in each individual store to receive announcements from that seller regarding their store and items for sale in their <a target="_blank" href="/pref_favorite.asp">My Favorite Stores</a> page.  The seller has an option to send an announcement to all members who are opted-in to receive announcements from that store by using the <a target="_blank" href="/help.asp?helpID=269">Contact Mailing List Form</a>.  Opt-out of each store's mailing list to which you opted-in on the same page or through a link on the bottom of each mailing list e-mail.
					</p>
				</div>

				<p>
					<h2>Data Feed to 3rd Party Applications:</h2>
				</p>

				<ul className="l-margin-left bullet-list l-margin-bottom">
					<li className="l-margin-bottom">
						<em>Peeron.com</em> - Sellers can opt-in and opt-out in their <a target="_blank" href="/pref_seller.asp">My Store Settings</a> page to allow Peeron.com to periodically download their store inventory through a special download created for Peeron.com which includes all data that can be downloaded on the <a target="_blank" href="/invExcel.asp">Download My Inventory</a> page.  This data is used in the <a target="_blank" href="http://www.peeron.com/inv/faq#stores">Peeron Associated Stores</a> program.
					</li>
					<li>
						<em>Offline Inventory Management Software</em> (<a target="_blank" href="/links.asp?catID=9">view list</a>) - Members opt-in by downloading the software and installing it on their computer.  The software might download your store inventory data available on the <a target="_blank" href="/invExcel.asp">Download My Inventory</a> page and order data available on the <a target="_blank" href="/orderExcel.asp">Download My Orders</a> page after you give the program your permission to download the data.
					</li>
				</ul>

				<p>
					<h2>Favorite Theme:</h2>
				</p>

				<div className="l-margin-left">
					<p>
						Each member has an option to select their favorite theme from a list of themes upon registration and can later change it in <a target="_blank" href="/pref_general.asp">My Personal Information</a> in MyBrickLink.  The favorite theme is used only to show which themes are most popular on the <a target="_blank" href="/catalogThemes.asp">Favorite Themes</a> page.  It is not used for marketing purposes or to display content based on the favorite theme.
					</p>
				</div>

				<p>
					<h2>Questions:</h2>
				</p>

				<div className="l-margin-left">
					<p>Contact the <a target="_blank" href="/helpDesk.asp">Help Desk</a> if you have any questions about this privacy policy.</p>
				</div>
			</div>
		);
	}
	*/

	calcMaxDayofMonth(year, month) {
		const maxDayByMonth = [ 31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31 ];
		let maxDay = 31;
		if ( (month > 0) && (month != 2) ) {
			maxDay = maxDayByMonth[month - 1];
		}
		else if (month == 2 ) {
			if (year > 0) {
				if ( (year % 4) == 0 ) {
					maxDay = 29;

					if ( (year % 100) == 0 ) 
					{
						if ( (year % 400) == 0 )
						{
							maxDay = 29;
						}
						else 
						{
							maxDay = 28;
						}
						
					} 
				}
				else {
					maxDay = 28;
				}
			}
			else {
				maxDay = 29;
			}
		}
		return maxDay;
	}

	convertToErrorMsg = ( ec ) =>
	{
		switch ( ec )
		{
		case "EC_INVALID_PARAM":			return $T( "ERR_INVALID_PARAM" );
		case "EC_SIGNUP_INVALID_EMAIL":		return $T( "ERR_SIGNUP_INVALID_EMAIL" );
		case "EC_SIGNUP_INVALID_USERNAME":	return $T( "ERR_SIGNUP_INVALID_USERNAME" );
		case "EC_SIGNUP_INVALID_PASSWORD":	return $T( "ERR_SIGNUP_INVALID_PASSWORD" );
		case "EC_SIGNUP_USERNAME_EXISTS":	return $T( "ERR_SIGNUP_USERNAME_EXIST" );
		case "EC_SIGNUP_EMAIL_EXISTS":		return $T( "ERR_SIGNUP_EMAIL_EXIST" );
		case "EC_SIGNUP_INVALID_COUNTRY":	return $T( "ERR_SIGNUP_INVALID_COUNTRY" );
		case "EC_SIGNUP_EMAIL_FAILURE":		return $T( "ERR_SIGNUP_EMAIL_FAILURE" );	
		case "EC_SIGNUP_CONSENT_REQUIRED":	return $T( "ERR_SIGNUP_CONSENT_REQUIRED" );
		}

		return $T( "ERR_UNKNOWN", [ ec ] );
	}
};

var $T = BLComponent.createTextMap( 
	{
		"ERR_UNKNOWN":
			{
				"en":	"Unknown Error! ({{$0}})"
			,	"kr":	"알수 없는 에러입니다. ({{$0}})"
			,	"es":	"Error desconocido! ({{$0}})"
			}
	,	"ERR_SIGNUP_INVALID_EMAIL":
			{
				"en":	"Email address is invalid."
			,	"kr":	"유효하지 않은 이메일 주소입니다."
			,	"es":	"La dirección de correo no es válida."
			}
	,	"ERR_SIGNUP_EMAIL_EXIST":
			{
				"en":	"This email is already in use."
			,	"kr": 	"이미 사용중인 이메일 주소입니다."
			,	"es":	"La dirección de correo ya está registrada."
			}
	,	"ERR_SIGNUP_USERNAME_EXIST":
			{
				"en":	"A user with that name already exists."
			,	"kr":	"이미 사용중인 유저네임입니다."
			,	"es":	"Ya existe un usuario con este nombre."
			}
	,	"ERR_SIGNUP_USERNAME_TOO_LONG":
			{
				"en":	"Username is exceeding 15 characters."
			,	"kr":	"유저네임이 15자를 초과하였습니다."
			,	"es":	"El nombre de usuario excede 15 caracteres."
			}
	,	"ERR_SIGNUP_INVALID_COUNTRY":
			{
				"en":	"Invalid Country!"
			,	"kr":	"잘못된 국가입니다."
			,	"es":	"El país no es válido."
			}
	,	"ERR_SIGNUP_INVALID_USERNAME":
			{
				"en":	"Username not allowed."
				,	"kr":	"사용할 수 없는 유저네임입니다."
				,	"es":	""			
			}
	,	"ERR_SIGNUP_EMAIL_FAILURE":
			{
				"en":	"Email Failure!"
			,	"kr":	"이메일 발송에 실패하였습니다."
			,	"es":	"Error procesando el correo."
			}
	,	"ERR_SIGNUP_INVALID_PASSWORD":
			{
				"en":	"Password is not valid. It may contain unsupported characters."
			,	"kr":	""
			,	"es":	"La contraseña no es valida. Puede contener caracteres no soportados."
			}
	,	"ERR_SIGNUP_CONSENT_REQUIRED":
			{
				"en":	"User consent to process data is required."
			,	"kr":	""
			,	"es":	"Es obligatorio el consentimiento del usuario para procesar sus datos."
			}
	}
);

document.addEventListener( "DOMContentLoaded", 
	function() {
		var	elem	=	ReactDOM.render(
							<RegisterMain blctx={{parent: null, idx:0}} />
						,	document.getElementById( 'bl-main' )
						);
		blapp.refs.register( "main", elem );
	}
);
